// European countries (Kosovo intentionally excluded — included under Srbija).
// Used by Register and Profile forms.
const EUROPEAN_COUNTRIES = [
  "Albanija",
  "Andora",
  "Austrija",
  "Belgija",
  "Belorusija",
  "Bosna i Hercegovina",
  "Bugarska",
  "Crna Gora",
  "Češka",
  "Danska",
  "Estonija",
  "Finska",
  "Francuska",
  "Grčka",
  "Hrvatska",
  "Holandija",
  "Irska",
  "Island",
  "Italija",
  "Kipar",
  "Letonija",
  "Lihtenštajn",
  "Litvanija",
  "Luksemburg",
  "Mađarska",
  "Malta",
  "Moldavija",
  "Monako",
  "Nemačka",
  "Norveška",
  "Poljska",
  "Portugal",
  "Rumunija",
  "Rusija",
  "San Marino",
  "Severna Makedonija",
  "Slovačka",
  "Slovenija",
  "Srbija",
  "Španija",
  "Švajcarska",
  "Švedska",
  "Turska",
  "Ujedinjeno Kraljevstvo",
  "Ukrajina",
  "Vatikan",
];

export default EUROPEAN_COUNTRIES;
